export default __webpack_public_path__ + "static/media/electrode.4fb60311.gif";